import { render, staticRenderFns } from "./catalogo-clientes.vue?vue&type=template&id=fe9c5070&"
import script from "./catalogo-clientes.vue?vue&type=script&lang=js&"
export * from "./catalogo-clientes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports